import useFlag from 'hooks/useFlag'
import type { Fields as Campaign } from 'models/Campaign'
import React from 'react'
import PushLegacy from './PushLegacy'
import PushRedesigned from './PushRedesigned'

type Props = {
  campaign: Campaign
}

// Kill-switch dispatcher for the DATA-4894 push composer redesign. When
// `mx-push-composer-redesign` is off (prod default) we render the pre-DATA-4894
// single-body-textarea form; when on, the redesigned title/subtitle/deep-link/
// image composer. Lets us revert the composer without a deploy.
const Push: React.FC<Props> = ({ campaign }) => {
  const showRedesign = useFlag('mx-push-composer-redesign', false)

  return showRedesign ? (
    <PushRedesigned campaign={campaign} />
  ) : (
    <PushLegacy campaign={campaign} />
  )
}

export default Push
